/*
 * @Description:
 * @Version:
 * @Autor: yqf
 * @Date: 2021-11-02 18:23:52
 * @LastEditors: 汪永康 wangyongkang@yxj.org.cn
 * @LastEditTime: 2025-09-23 09:43:48
 * @FilePath: \yxj-mall-h5\src\router\index.js
 */
import Vue from "vue";
import Router from "vue-router";
import store from "../store";
import { updateBreadcrumbStack } from "@/utils/breadcrumb";
//获取原型对象上的push函数
const originalPush = Router.prototype.push
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

function routers() {
  const Home = () => import("../views/index.vue");	// 首页
  const LoginRegister = () => import("../views/LoginRegister/index.vue");	// 登录注册
  const InputInformation = () => import("../views/LoginRegister/InputInformation.vue");	// 输入信息
  const welcome = () => import("../views/LoginRegister/welcome.vue");	// 欢迎页
  const forgotPassword = () => import("../views/LoginRegister/forgotPassword.vue");	// 忘记密码
  const resetPassword = () => import("../views/LoginRegister/resetPassword.vue");	// 重置密码
  const resetPasswordSuccess = () => import("../views/LoginRegister/resetPasswordSuccess.vue");	// 重置密码成功

  const router = [
    {
      path: "/",
      name: "Layouts",
      component: () => import("@/layouts/default"),
      children: [
        {
          // 默认首页：访问 `/` 直接渲染首页组件，同时兼容旧入口 `/oriental_express`
          path: "",
          alias: "/oriental_express",
          name: "home",
          component: Home,
          meta: {
            keepAlive: true,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/latestnews",
          name: "latestnews",
          component: ()=>import('../views/orientalExpress/latestnews.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/people",
          name: "people",
          component: ()=>import('../views/orientalExpress/people.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/clinicalPulse",
          name: "clinicalPulse",
          component: ()=>import('../views/clinicalPulse/index.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/clinicalPulse/list",
          name: "clinicalPulseList",
          component: ()=>import('../views/clinicalPulse/list.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/partnership",
          name: "partnership",
          component: ()=>import('../views/partnership/index.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/partnership/list",
          name: "partnershipList",
          component: ()=>import('../views/partnership/list.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/about",
          name: "about",
          component: ()=>import('../views/about/index.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/articleDetails",
          name: "articleDetails",
          component: ()=>import('../views/articleDetails/index.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/previewArticle",
          name: "previewArticle",
          component: ()=>import('../views/articleDetails/previewArticle.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/share/wechat",
          name: "wechatShare",
          component: ()=>import('../views/share/wechat.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'WeChat Share'
          }
        },
        // 2.0模块列表路由
        {
          path: "/innovationTracker/list",
          name: "innovationTrackerList",
          component: ()=>import('../views/listGather/innovationTracker.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Innovation Tracker List'
          }
        },
        {
          path: "/deepAnalysis/list",
          name: "deepAnalysisList",
          component: ()=>import('../views/listGather/deepAnalysis.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Deep Analysis List'
          }
        },
        {
          path: "/latestNews/list",
          name: "latestNewsList",
          component: ()=>import('../views/listGather/latestNews.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Latest News List'
          }
        },
        {
          path: "/frontierResearch/list",
          name: "frontierResearchList",
          component: ()=>import('../views/listGather/frontierResearch.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Frontier Research List'
          }
        },
        {
          path: "/doctors/list",
          name: "doctorsList",
          component: ()=>import('../views/listGather/doctors.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Doctors List'
          }
        },
        {
          path: "/conferences/contentAddCollection/list",
          name: "contentList",
          component: ()=>import('../views/listGather/contentAddCollection.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Content Add Collection List'
          }
        },
        {
          path: "/conferences/contentLists/list",
          name: "contentLists",
          component: ()=>import('../views/listGather/conferencesContentLists.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Content Lists'
          }
        },
        {
          path: "/conferences/collectionLists/list",
          name: "conferencesCollectionLists",
          component: ()=>import('../views/listGather/conferencesCollectionLists.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Conferences Collection Lists'
          }
        },
        {
          path: "/webinar/contentAddCollection/list",
          name: "webinarContentAddCollection",
          component: ()=>import('../views/listGather/webinarContentAddCollection.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Webinar Content Add Collection'
          }
        },
        {
          path: "/webinar/contentLists/list",
          name: "webinarContentLists",
          component: ()=>import('../views/listGather/webinarContentLists.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Webinar Content Lists'
          }
        },
        {
          path: "/webinar/collectionLists/list",
          name: "webinarCollectionLists",
          component: ()=>import('../views/listGather/webinarCollectionLists.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Webinar Collection Lists'
          }
        },
        {
          path: "/search",
          name: "Search",
          component: ()=>import('../views/search/index.vue'),
          meta: {
            keepAlive: true,
            buriedTitle: 'Oriental Express'
          }
        },
        {
          path: "/user_center",
          name: "userCenter",
          component: ()=>import('../views/userCenter/index.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'User Center'
          }
        },
        {
          path: "/privacy",
          name: "Privacy",
          component: ()=>import('../views/about/privacy.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Privacy Policy'
          }
        },
        {
          path: "/terms",
          name: "Terms",
          component: ()=>import('../views/about/terms.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'Terms of Use'
          }
        },
        {
          path: "/thirdParties",
          name: "thirdParties",
          component: ()=>import('../views/about/thirdParties.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'thirdParties'
          }
        },
        {
          path: "/privacy_us",
          name: "privacy_us",
          component: ()=>import('../views/about/privacy_Us.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'privacyUs'
          }
        },
        {
          path: "/privacy_europe",
          name: "privacy_europe",
          component: ()=>import('../views/about/privacy_europe.vue'),
          meta: {
            keepAlive: false,
            buriedTitle: 'privacyEurope'
          }
        },
      ]
    },
    {
      path: "/login_register",
      name: "LoginRegister",
      component: LoginRegister,
      meta: {
        keepAlive: false,
        buriedTitle: 'Login Register',
        module:'LoginRegister'
      }
    },
    {
      path: "/input_information",
      name: "InputInformation",
      component: InputInformation,
      meta: {
        keepAlive: false,
        buriedTitle: 'Input Information',
        module:'LoginRegister'
      }
    },
    {
      path: "/welcome",
      name: "welcome",
      component: welcome,
      meta: {
        keepAlive: false,
        buriedTitle: 'welcome',
        module:'LoginRegister'
      }
    },
    {
      path: "/forgot_password",
      name: "forgotPassword",
      component: forgotPassword,
      meta: {
        keepAlive: false,
        buriedTitle: 'Forgot Password',
        module:'LoginRegister'
      }
    },
    {
      path: "/reset_password",
      name: "resetPassword",
      component: resetPassword,
      meta: {
        keepAlive: false,
        buriedTitle: 'Reset Password',
        module:'LoginRegister'
      }
    },
    {
      path: "/reset_password_success",
      name: "resetPasswordSuccess",
      component: resetPasswordSuccess,
      meta: {
        keepAlive: false,
        buriedTitle: 'Reset Password',
        module:'LoginRegister'
      }
    },
	];
	return router;
}

// router对象工厂
function routerFactory() {
  // 加载路由
  const router = routers();
  const routerObj = new Router({
    routes: router,
    // 使用 history 模式（不再出现 #/）
    mode: 'history',
    // Vue CLI 基础路径（部署在子目录时使用）
    base: process.env.BASE_URL || "/",
    // 统一滚动规则：
    // 1) 浏览器返回/前进：恢复历史滚动位置
    // 2) 其他路由跳转：回到顶部
    scrollBehavior(to, from, savedPosition) {
      if (savedPosition) {
        return savedPosition
      }
      return { x: 0, y: 0 }
    }
  });
  // 面包屑：记录用户页面跳转链路（session 级别）
  routerObj.afterEach((to) => {
    updateBreadcrumbStack(to);
  });
  // 全局router守卫
  routerObj.beforeEach(async (to, from, next) => {
    console.log('to',to)
    // const screenWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth
    // if(screenWidth <= 768) {
    //   window.location.href = process.env.VUE_APP_MOBILE_ONLINE
    // }
    
    if (to.path==='/login_register'&&!from.meta.module&&from.meta.module!=='LoginRegister') {
      localStorage.setItem('oldPath',from.fullPath)
    }
    if (localStorage.getItem('ysz_web_international_token')) {
      store.dispatch('setIsLogin',true)
      store.dispatch('setUserInfo',JSON.parse(localStorage.getItem('userInfo')))
    }
    next()
  });

  return routerObj;
}



export default routerFactory();
